export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.api.clubside.us/'
};